const HelpArticles = () => import("Core/configuration/help_articles/views/Articles");
const CreateArticle = () => import("Core/configuration/help_articles/views/CreateArticle");
const TranslateArticles = () => import("Core/configuration/help_articles/views/TranslateArticles");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "configuration/help_articles",
            name: "help_articles",
            component: HelpArticles,
            meta: {
                requiresAuth: true,
                title: "lang.help_articles",
            },
        },
        {
            path: "configuration/help_articles/translate",
            name: "help_articles_translate",
            component: TranslateArticles,
            meta: {
                requiresAuth: true,
                title: "lang.translate_articles",
            },
        },
        {
            path: "configuration/help_articles/add",
            name: "help_articles_add",
            component: CreateArticle,
            meta: {
                requiresAuth: true,
                title: "lang.create_articles",
            },
        },
    ],
};
